/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import Dropdown from './dropdown';
import MobileHeader from './mobileHeader';
// React useState
import { useState } from 'react';
// React Router
import { Link } from "react-router-dom";
// Images
import logo from '../assets/logo.svg';
import Browse from '../assets/images/navigation/browse.svg';
import Discord from '../assets/images/navigation/discord.svg';
import Domain from '../assets/images/navigation/domain.svg';
import Reseller from '../assets/images/navigation/reseller.svg';
import Transfer from '../assets/images/navigation/transfer.svg';
import Website from '../assets/images/navigation/website.svg';
import About from '../assets/images/navigation/about.svg';
import Knowledgebase from '../assets/images/navigation/knowledgebase.svg';
import Partners from '../assets/images/navigation/partners.svg';
import Contact from '../assets/images/navigation/contact.svg';
import Affiliates from '../assets/images/navigation/affiliates.svg';
import Node from '../assets/images/navigation/node.svg';

const Header = () => {
    // Dropdown State
    const [activeDropdown, setDropdown] = useState(0);
    // Hosting Options
    const hostingOptions = [
        { name: 'Browse all Games', icon: Browse, description: 'All Game Servers we offer', link: '/games', linkType: 'route' },
        { name: 'Discord Bot Hosting', icon: Discord, description: 'Get your Discord Bot online', link: '/hosting/discord', linkType: 'route' },
        { name: 'Domain Registration', icon: Domain, description: 'Access your Website anywhere', link: 'https://client.cyperhost.com/cart.php?a=add&domain=register', linkType: 'link' },
        { name: 'Reseller Hosting', icon: Reseller, description: 'Web-Hosting for your clients', link: '/hosting/reseller', linkType: 'route' },
        { name: 'Transfer a Domain', icon: Transfer, description: 'Bring your domain to us', link: 'https://client.cyperhost.com/cart.php?a=add&domain=transfer', linkType: 'link' },
        { name: 'Website Hosting', icon: Website, description: 'Get your Website online', link: '/hosting/web-hosting', linkType: 'route' }
    ]
    // Information Options
    const infoOptions = [
        { name: 'About Us', icon: About, description: 'Learn more about us', link: '/about', linkType: 'route' },
        { name: 'Knowledgebase', icon: Knowledgebase, description: 'General help for services', link: 'https://help.cyperhost.com/', linkType: 'link' },
        { name: 'Partners', icon: Partners, description: 'Our partnerships', link: '/partners', linkType: 'route' },
        { name: 'Contact Us', icon: Contact, description: 'Reach out to us', link: 'https://client.cyperhost.com/submitticket.php', linkType: 'link' },
        { name: 'Affiliates', icon: Affiliates, description: 'Promote & make money', link: '/affiliates', linkType: 'route' },
        { name: 'Node Stats', icon: Node, description: 'Our node statistics', link: 'https://status.cyperhost.com/', linkType: 'link' }
    ]

    return (
        <header className="grid grid-cols-4 gap-3 items-center py-6 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5">
            <div className="brand col-span-2 sm:col-span-2 md:col-span-2 lg:col-span-1">
                <Link to='/'>
                    <img src={logo} alt="Cyperhost" className="w-36 sm:w-36 md:w-36 lg:w-48 min-w-36 sm:min-w-36 md:min-w-36 lg:min-w-48"  />
                </Link>
            </div>
            <div className="nav-links flex justify-center col-span-2 hidden sm:hidden md:hidden lg:block">
                <ul className="flex justify-center items-center">
                    <li className="pr-6 text-gray-300 hover:text-white hover:underline text-lg font-medium">
                        <Link to="/games/minecraft">Minecraft Hosting</Link>
                    </li>
                    <li className="px-6">
                        <a onClick={() => activeDropdown === 1 ? setDropdown(0) : setDropdown(1)} className="cursor-pointer select-none text-gray-300 hover:text-white hover:underline text-lg flex items-center font-medium">
                            Other Services
                            {activeDropdown === 1 ?
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                                </svg>
                            :
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                </svg>
                            }
                        </a>
                        {activeDropdown === 1 ? <Dropdown title='Services' items={hostingOptions} hidden={false} /> : <Dropdown title='Services' items={hostingOptions} hidden={true} />}
                    </li>
                    <li className="pl-6">
                        <a onClick={() => activeDropdown === 2 ? setDropdown(0) : setDropdown(2)} className="cursor-pointer select-none text-gray-300 hover:text-white hover:underline text-lg flex items-center font-medium">
                            Information
                            {activeDropdown === 2 ?
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                                </svg>
                            :
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                </svg>
                            }
                        </a>
                        {activeDropdown === 2 ? <Dropdown title='Information' items={infoOptions} hidden={false} /> : <Dropdown title='Information' items={infoOptions} hidden={true} />}
                    </li>
                </ul>
            </div>
            <div className="cto text-right hidden sm:hidden md:hidden lg:block">
                <a href="https://client.cyperhost.com/" className="bg-primary hover:bg-secondary px-7 py-2 text-gray-100 hover:text-white rounded-full transition">Sign in</a>
            </div>
            <MobileHeader />
        </header>
    )
}

export default Header